import axios from 'axios/index';
import React, {PureComponent} from 'react';

import { Classes, Overlay } from "@blueprintjs/core";
import toastr from 'toastr';
import { getCurrentUserId, getJwt } from '../../services/authService';
import http from '../../services/httpService';
import InputRegular from '../common/InputRegular';

export default class VatCheckFailedModalNew extends PureComponent{
    state={
        overlayIsOpen: false,
        viberEnableRequests: '',
        loaderActive: false,
        changeVatNumberActive: '',
        vatNumber: '',
        loader: false
    }
    handleClose = () => {
        this.setState({
            overlayIsOpen: false
        })
    }

    componentDidMount(){
        this.setState({
            overlayIsOpen: this.props.showModal,
        })
    }
    componentDidUpdate(){
        if (this.state.overlayIsOpen !== this.props.showModal){
            this.setState({
                overlayIsOpen: this.props.showModal
            })
        }
    }
    handleUpdateBillingDetails = async (vatNumber, continueAnyWay) => {
        let paymentMethodId = await this.props.vatCheckFailedData.paymentMethodId;
        let user = await this.props.user;
        let projectId = this.props.projectId;

        try {
            const resultUpdateBillingDetails = await http.post(
                'api/user/' + user.id + '/project/' + projectId + '/pm/' + paymentMethodId + '/update',
                {
                    "billing_details": {
                        "address": {
                            "city": this.props.billingDetails.address.city,
                            "country": this.props.billingDetails.address.country,
                            "line1": this.props.billingDetails.address.line1,
                            "line2": null,
                            "postal_code": this.props.billingDetails.address.postal_code,
                            "state": this.props.billingDetails.address.state
                        },
                        "email": this.props.billingDetails.email,
                        "phone": this.props.billingDetails.phone,
                        "company_name": this.props.billingDetails.company_name,
                        "billing_name": this.props.billingDetails.billing_name,
                        "vat_number": vatNumber,
                        "po_number": this.props.billingDetails.po_number,
                    }
                },
                {headers: {authorization: getJwt()}}
            )
            if(continueAnyWay === 'handleContinueAnyWay'){
                this.props.handleContinueAnyWay();
            }else{
                this.props.updatePaymentMethods();
                this.props.updateUserFromServer();
            }
            await this.props.handleClose();
            await this.props.handleCloseMainModal();
            toastr.success('Billing Details were successfully saved');
        } catch(e) {
            toastr.error("Billing details update wasn't successful.");
        }
    }

    handleCheckVat = async () => {
        // let listOfEuAbbreviations = ['BE', 'BG', 'CZ', 'DK', 'DE', 'EE', 'IE', 'EL', 'ES', 'FR', 'GR', 'HR', 'IT', 'CY', 'LV',
        //     'LT', 'LU', 'HU', 'MT', 'NL', 'AT', 'PL', 'PT', 'RO', 'SI', 'SK', 'FI', 'SE'];
        // let shouldAddVat = false;
        let country = this.props.vatCheckFailedData.country;
        let projectId = this.props.projectId;
        let paymentId = this.props.vatCheckFailedData.vatCheckPaymentMethodId;
        let user = this.props.user;
        // if(this.state.vatNumber && country){
        //     await listOfEuAbbreviations.map(countryId=>countryId === country ? shouldAddVat = true : '' );
        // }
        // console.log('vat data: ', vatNumber, country, shouldAddVat)

        this.setState({loader:true})
        try {
            const checkVatResult = await http.post('api/user/' + user.id + '/project/' + projectId + '/test_vat', {
                "vat_number": this.state.vatNumber,
                // "payment_method": paymentId,
                // "country_to_check": country
            }, { headers: { authorization: getJwt() } });
            if(checkVatResult.data.vat_details && checkVatResult.data.vat_details.valid){
                await this.handleUpdateBillingDetails(this.state.vatNumber);
                await this.setState({loader: false})
            }else{
                toastr.error('VAT number is not valid')
                this.setState({
                    changeVatNumberActive: false,
                    loader: false
                })
            }
        }catch(e){
            toastr.error('VAT number is not valid')
            this.setState({
                changeVatNumberActive: false,
                loader: false
            })
        }
    }

    render(){
        return(
            <Overlay
                onClose={this.props.handleClose} className={Classes.OVERLAY_SCROLL_CONTAINER} isOpen={this.state.overlayIsOpen}
                canOutsideClickClose={false}
                style={{
                    display: 'flex',
                    flex: 1,
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <div className="modal-field" style={{width: this.props.width || '60%', maxWidth: this.props.maxWidth || '100%'}}>
                    <p className="modal-close-button" onClick={ () =>{this.props.handleClose()} }><i className="fas fa-times"></i></p>
                    <div className="onboarding-panel">
                        <h1 className="m-m-b">Invalid VAT Number</h1>
                        <div className="separator"></div>
                        <div className="form-group m-m-b" style={{marginTop: 20}}>

                            <span>This is not a valid VAT number, please check your input or proceed anyway(VAT number will not be saved).</span>
                        </div>
                        {
                            this.state.changeVatNumberActive && this.state.vatNumber ?
                                <InputRegular
                                    id="1"
                                    label1="VAT Number"
                                    label2=" "
                                    placeholder=""
                                    // required={true}
                                    type='text'
                                    onChange={ value => this.setState({ vatNumber: value })}
                                    value={ this.state.vatNumber }
                                    fieldsCheckActive={ false }
                                    //updateErrorsList={updateErrorsList}
                                />
                                :
                                ''
                        }
                        {/*<div className="separator m-m-b"></div>*/}
                        {
                            this.state.changeVatNumberActive && this.state.vatNumber ?
                                <div style={{display: 'flex', alignItems: 'space-between'}}>
                                    <button
                                        disabled={ false }
                                        onClick={ () =>{
                                            this.setState({
                                                changeVatNumberActive: false,
                                                vatNumber: ''
                                            })
                                        } }
                                        name="cancel_delete_tag"
                                        id="cancel_delete_tag"
                                        type="button"
                                        className='btn-action btn-sm m-sm-b center'
                                    >
                                        Cancel
                                    </button>
                                    {
                                        this.state.loader ?
                                            <button
                                                disabled={ true }
                                                type="button"
                                                className='btn-action btn-action-spinner btn-sm m-sm-b center'
                                            >
                                                Check VAT  <i className='fa fa-spin fa-spinner'></i>
                                            </button>
                                            :
                                            <button
                                                disabled={ false }
                                                onClick={ this.handleCheckVat }
                                                type="button"
                                                className='btn-action btn-sm m-sm-b center'
                                            >
                                                Check VAT
                                            </button>

                                    }

                                </div>
                                :
                                <div style={{display: 'flex', alignItems: 'space-between'}}>
                                    <button
                                        disabled={ false }
                                        onClick={ () =>{
                                            this.setState({
                                                changeVatNumberActive: true,
                                                vatNumber: this.props.vatCheckFailedData.vatNumber
                                            })
                                        }}
                                        name="cancel_delete_tag"
                                        id="cancel_delete_tag"
                                        type="button"
                                        className='btn btn-action btn-sm m-sm-b center'
                                    >
                                        Change VAT Number
                                    </button>

                                    <button
                                        disabled={ false }
                                        onClick={ () =>{
                                            this.handleUpdateBillingDetails(this.props.vatCheckFailedData.vatNumber, 'handleContinueAnyWay');
                                        } }
                                        type="button"
                                        className='btn-action btn-sm m-sm-b center'
                                    >
                                        Proceed Anyway
                                    </button>

                                </div>
                        }
                    </div>
                </div>
            </Overlay>
        )
    }
}